import { AfterViewInit, Component, HostListener, inject, OnInit, signal, TemplateRef } from "@angular/core";
import { NavigationCancel, NavigationEnd, NavigationError, Router, RouterModule } from "@angular/router";
import { AlertService, UserService } from "@company-box/services";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { User } from "@company-box/models";
import { filter, timer } from "rxjs";
import { CommonModule } from "@angular/common";
import { LoginModalComponent } from "./login-modal/login-modal.component";
import { NavRightComponent } from "./nav-right/nav-right.component";
import { AppHeaderComponent } from "./app-header/app-header.component";
import { AppFooterComponent } from "./app-footer/app-footer.component";
import { CBAuthService } from "../../services/cb-auth.service";
import { CheckoutService } from "../../../../../libs/services/src/lib/checkout.service";

@Component({
  selector: "app-common-layout",
  templateUrl: "./common-layout.component.html",
  styleUrls: ["./common-layout.component.scss"],
  imports: [
    AppHeaderComponent,
    AppFooterComponent,
    CommonModule,
    RouterModule,
    LoginModalComponent,
    NavRightComponent,
  ],
})
export class CommonLayoutComponent implements OnInit, AfterViewInit {
  public config: any;

  public navbarOpen = signal<boolean>(false);
  public sidebarOpen = false;

  private innerWidth: number | undefined;
  private modal: BsModalRef | undefined;
  public user = signal<User|undefined>(undefined);
  public cartEmpty = signal(true);
  private userService = inject(UserService);
  private alertSvc = inject(AlertService);
  private router: Router = inject(Router);
  private bsModalService: BsModalService = inject(BsModalService);
  private authService: CBAuthService = inject(CBAuthService);
  private checkoutService = inject(CheckoutService);

  cartLength = 0;

  constructor() {}

  ngOnInit() {
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd || e instanceof NavigationCancel || e instanceof NavigationError))
      .subscribe(() => {
        this.navbarOpen.set(false);
        this.updateSidebar();
      });

    this.userService.update$.subscribe((value: User) => {
      this.user.set(value);
    });

    this.authService.update$.subscribe(() => {
      this.userService.getCurrentUser().then(
        (user) => this.user.set(user),
        () => this.user.set(undefined)
      );
    });

    this.userService
      .getCurrentUser()
      .then((value) => {
        this.user.set(value);
      })
      .catch((error) => {
        console.log(error);
      });

    this.checkoutService
      .getCheckoutDetails()
      .then((response) => {
        this.cartLength = response.lineItems.length;
        this.setCartState();
      })
      .catch(() => {
        this.cartLength = 0;
        this.setCartState();
      });
  }

  @HostListener("window:resize", ["$event"])
  onResize(_event: any) {
    this.updateSidebar();
  }

  ngAfterViewInit(): void {
    timer(1).subscribe(() => {
      this.updateSidebar();
    });
  }

  private updateSidebar() {
    this.innerWidth = window.innerWidth;
    this.sidebarOpen = this.innerWidth > 991;
  }

  toggleMenu() {
    this.navbarOpen.set(!this.navbarOpen());
  }

  showModal(template: TemplateRef<any>) {
    this.modal = this.bsModalService.show(template);
  }
  hide() {
    this.modal?.hide();
  }

  logout() {
    this.userService.logout().then(
      () => {
        this.router.navigate(["/start"]).then(() => {
          window.location.reload();
        });
      },
      () => {
        this.alertSvc.showWarning({ msg: "Something went wrong while logging out" });
      }
    );
  }

  setCartState() {
    if(this.cartLength === 0) this.cartEmpty.set(true);
    else this.cartEmpty.set(false);
  }
}
